export function removeRenderedLayoutStyles(classNames: string): string
{
    return classNames
        .split(' ')
        .filter(className => !className.startsWith('wp-container-'))
        .join(' ');
}